import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

import DatePicker from "react-datepicker";

var CurrentUser = require("lib/account/CurrentUser");
var AccountPlans = require("lib/account/AccountPlans");

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var CRMTitleSelector = require("components/utility/inputs/CRMTitleSelector");
var AgentTaskForm = require("components/appdev/crm/AgentTaskForm");

import moment from "moment";

require("appdev/crm/deal_received_page.scss");

@connect(
	(state, props) => {
		var dealID = $wr.getURLParameterByName("deal_id");

		if (dealID) {
			var deal = CRMSelectors.deal({ state, id: $wr.getURLParameterByName("deal_id") });

			if (deal) {
				var org = deal.org;

				var stage = CurrentUser.get().crm_config.stages[deal.stage_id];

				if (org.custom_fields["Canonical School ID"]) {
					var filters = { canonical_school_id: org.custom_fields["Canonical School ID"] };
				} else if (org.custom_fields["Canonical District ID"]) {
					var filters = { canonical_district_id: org.custom_fields["Canonical District ID"] };
				}

				var estimates = CRMSelectors.estimates({ state, filters });

				var invoiceNum = deal.custom_fields["Invoice No."];
			}
		}

		var loading = CRMSelectors.isLoadingDeals({ state, key: dealID }) || 
			CRMSelectors.isLoadingEstimates({ state }) ||
			CRMSelectors.isLoadingInvoices({ state, key: "create" }) ||
			CRMSelectors.isLoadingInvoices({ state, key: invoiceNum });

		return {
			deal, stage, estimates, loading,
			qbPaymentConfig: CurrentUser.get().crm_config.quickbooks_payment_methods
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			var dealID = $wr.getURLParameterByName("deal_id");
			if (dealID) {
				return dispatch(CRMActions.fetchDeal({
					id: dealID, embeds: ["deal.org", "deal.contact"]
				})).then((data) => {
					var org = data.deals[0].org;
					if (org.custom_fields["Canonical School ID"]) {
						var query = { canonical_school_id: org.custom_fields["Canonical School ID"] };
					} else if (org.custom_fields["Canonical District ID"]) {
						var query = { canonical_district_id: org.custom_fields["Canonical District ID"] };
					}
					return dispatch(CRMActions.fetchEstimates({ query }));
				})
			}
		},
		createInvoice: (estimateID, poNumber, dealID) => {
			return dispatch(CRMActions.createInvoice({
				invoice: { po_number: poNumber, estimate_id: estimateID },
				query: { deal_id: dealID }
			})).then((response) => {
				return response.invoices[0];
			})
		},
		registerPayment: (invoiceNumber, paymentRef, qbPaymentMethodID) => {
			return dispatch(CRMActions.updateInvoice({ 
				id: invoiceNumber,
				query: {
					by_invoice_no: true,
					receive_payment: true,
					payment_ref: paymentRef,
					payment_method_id: qbPaymentMethodID,
				}
			}))
		},
		updateDeal: (dealID, update, tasks, contacts, files) => {
			return dispatch(CRMActions.updateDeal({
				id: dealID, update, files, nextTasks: tasks, newContacts: contacts,
				embeds: ["deal.org"]
			}))
		}
	})
)
@providePopulateData({ waitForLoad: true })
class DealReceivedPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.poUploadRef = React.createRef();

		if (props.deal) {
			var fundingSource = props.deal.custom_fields["Funding"] || "";
			var paymentMethod = props.deal.custom_fields["Payment Method"] || "";
			var paymentID = props.deal.custom_fields["Payment ID"] || "";

			var meetingDate = props.deal.custom_fields["Meeting Date"];
			var decisionDate = props.deal.custom_fields["Decision Date"];
			var paymentDate = props.deal.custom_fields["Payment Date"];

			var paymentRef = props.deal.custom_fields["Payment Ref."] || "";
		}

		this.state = {
			task: {
				active: true,
				date: undefined,
				text: undefined,
				agentEmail: (props.deal.owner || {}).email
			},
			selectedEstimateID: "",

			selectedChange: "",

			fundingSource, paymentMethod, paymentID, 
			meetingDate, decisionDate, paymentDate,
			paymentRef,

			payableTitle: "",
			payableFirstName: "",
			payableLastName: "",
			payableEmail: "",

			qbPaymentMethodID: "",

			poFileSize: null,
			done: false
		};
	}

	effectiveTask() {
		var task = _.clone(this.state.task);

		if (this.state.selectedChange == "Quote Accepted") {
			task.date = task.date || moment().add(7, "days").format("YYYY-MM-DD");
			task.text = task.text || "Accepted FU 1";

		} else if (this.state.selectedChange == "PO Received") {
			task.date = task.date || moment().add(14, "days").format("YYYY-MM-DD");
			task.text = task.text || "Invoice FU - Due " + moment().add(30, "days").format("MMM D");

		} else if (this.state.selectedChange == "Payment Received") {
			task.date = task.date || moment().format("YYYY-MM-DD");
			task.text = task.text || "Move to won";
		}

		return task
	}

	getTasks() {
		var task = this.effectiveTask();

		if (task && task.active && task.text) {
			return [{
				due_date: task.date,
				content: task.text,
				owner_email: task.agentEmail
			}]
		}

	}

	getNewContacts() {
		if (this.state.payableLastName) {
			return [{
				title: this.state.payableTitle,
				first_name: this.state.payableFirstName,
				last_name: this.state.payableLastName,
				email: this.state.payableEmail,
			}]
		}
	}

	selectedEstimate() {
		if (this.state.selectedEstimateID) {
			return _.findWhere(this.props.estimates, { id: this.state.selectedEstimateID });
		}
	}

	updateTask(key, value) {
		var task = _.extend({}, this.state.task, { [key]: value });
		this.setState({ task })
	}

	defaultMeetingDate() {
		return (new Date()).getFullYear() + "-01-01";
	}

	onFileInput() {
		if (this.poUploadRef.current && this.poUploadRef.current.files[0]) {
			var file = this.poUploadRef.current.files[0];
			this.setState({ poFileSize: file.size });
		} else {
			this.setState({ poFileSize: null });
		}
	}

	//////////////////////////////
	// Submitting Form ///////////
	//////////////////////////////

	submitQuoteAccepted() {
		var estimate = this.selectedEstimate();

		var dealUpdate = {};

		var success = this.applyQuoteAcceptedFields(dealUpdate);

		if (estimate && !success) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Missing Fields!", text: "A required field is missing for this stage change", 
				icon: "exclamation-sign", type: "error"
			});
			return;
		}

		this.applyQuickbooksItemInfo(dealUpdate, this.selectedEstimate());

		dealUpdate.stage = "Quote Accepted";

		this.props.updateDeal(this.props.deal.id, dealUpdate, this.getTasks()).then(() => {
			this.setState({ done: true });
		})

	}

	submitPORecevied() {
		var dealUpdate = {};

		var poFile = this.poUploadRef.current.files[0];

		if (!poFile) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Missing Fields!", text: "Upload the PO File", 
				icon: "exclamation-sign", type: "error"
			});
			return;
		}

		var success = this.applyQuoteAcceptedFields(dealUpdate) &&
			this.applyPOReceivedFields(dealUpdate);

		if (!success) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Missing Fields!", text: "A required field is missing for this stage change", 
				icon: "exclamation-sign", type: "error"
			});
			return;
		}

		$wr.toBase64(this.poUploadRef.current.files[0]).then((poData) => {

			if (this.state.selectedEstimateID) {
				this.props.createInvoice(
					this.state.selectedEstimateID,
					this.state.paymentID,
					this.props.deal.id
				).then((invoice) => {
					const poNameParts = [
						"PO", moment().format("YYYY-MM-DD"),
						this.props.deal.org.name, 
						"Deal " + this.props.deal.id
					]
					const poName = poNameParts.join(" - ") + ".pdf";

					var invoiceNum = invoice.doc_number;
					this.applyQuickbooksItemInfo(dealUpdate, this.selectedEstimate());

					dealUpdate.stage = "PO Received";

					dealUpdate.custom_fields = dealUpdate.custom_fields || {};
					dealUpdate.custom_fields["Invoice No."] = invoiceNum;

					this.props.updateDeal(
						this.props.deal.id, 
						dealUpdate, 
						this.getTasks(), 
						this.getNewContacts(),
						{ [poName]: poData },
					).then((response) => {
						var updatedDeal = (response.deals || [])[0];
						if (updatedDeal.org) {
							var driveID = updatedDeal.org.custom_fields["Drive ID"]
							window.open("https://drive.google.com/drive/u/0/folders/" + driveID);
						}

						this.setState({ done: true });
					})
				})
			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "No estimate selected!", text: "Select an estimate from the drop down", 
					icon: "exclamation-sign", type: "error" });
			}
		})
	}

	submitPaymentRecevied() {
		var dealUpdate = {};

		var success = this.applyQuoteAcceptedFields(dealUpdate) &&
			this.applyPOReceivedFields(dealUpdate) &&
			this.applyPaymentReceivedFields(dealUpdate);

		if (!success) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Missing Fields!", text: "A required field is missing for this stage change", 
				icon: "exclamation-sign", type: "error"
			});
			return;
		}


		const submitHelper = (invoiceNumber) => {
			this.props.registerPayment(invoiceNumber, this.state.paymentRef, this.state.qbPaymentMethodID).then(() => {
				this.props.updateDeal(this.props.deal.id, dealUpdate, this.getTasks()).then(() => {
					this.setState({ done: true });
				})
			})
		}

		if (this.props.stage == "PO Received") {
			const invoiceNum = this.props.deal.custom_fields["Invoice No."];

			if (!invoiceNum) {
				window.wrNotifications.triggerDropDownNotification({
					title: "No Invoice No.!", text: "The invoice number is missing from this PO Received deal", 
					icon: "exclamation-sign", type: "error"
				});
				return;
			}

			submitHelper(invoiceNum);

		} else {
			this.props.createInvoice(this.state.selectedEstimateID, this.state.paymentID).then((invoice) => {

				var invoiceNum = invoice.doc_number;
				this.applyQuickbooksItemInfo(dealUpdate, this.selectedEstimate());

				dealUpdate.stage = "PO Received";

				dealUpdate.custom_fields = dealUpdate.custom_fields || {};
				dealUpdate.custom_fields["Invoice No."] = invoiceNum;

				submitHelper(invoiceNum);
			})

		}
	}



	//////////////////////////////
	// Submitting Helpers ////////
	//////////////////////////////

	applyQuoteAcceptedFields(deal) {
		deal.custom_fields = deal.custom_fields || {};

		if (this.state.decisionDate) {
			deal.custom_fields["Decision Date"] = this.state.decisionDate;
		} else {
			return false
		}

		if (!deal.custom_fields["Meeting Date"]) {
			deal.custom_fields["Meeting Date"] = this.defaultMeetingDate();
		}

		return true;
	}

	applyPOReceivedFields(deal) {
		deal.custom_fields = deal.custom_fields || {};

		if (this.state.fundingSource) {
			deal.custom_fields["Funding"] = this.state.fundingSource;
		} else {
			return false
		}

		if (this.state.paymentMethod) {
			deal.custom_fields["Payment Method"] = this.state.paymentMethod;
		} else {
			return false
		}

		if (this.state.paymentID) {
			deal.custom_fields["Payment ID"] = this.state.paymentID;
		} else {
			return false
		}

		return true;
	}

	applyPaymentReceivedFields(deal) {
		deal.custom_fields = deal.custom_fields || {};

		if (this.state.paymentDate) {
			deal.custom_fields["Payment Date"] = this.state.paymentDate;
		} else {
			return false
		}

		if (this.state.paymentRef) {
			deal.custom_fields["Payment Ref."] = this.state.paymentRef;
		} else {
			return false
		}

		if (!this.state.qbPaymentMethodID) {
			return false
		}

		return true;
	}

	applyQuickbooksItemInfo(deal, qbItem) {
		var value = parseFloat(qbItem.total) * 100;
		var plan = AccountPlans.name(qbItem.plan)

		var classCount = 0;
		var teacherCount = 0;
		var hasRLDs = false;

		qbItem.line_items.forEach((item) => {
			if (item.sales_line_item_detail) {
				var name = item.sales_line_item_detail.item_ref.name;
				var count = parseInt(item.sales_line_item_detail.quantity);
				if (name.includes("Diagnostic")) {
					hasRLDs = true;
				} else if (name.includes("Classes")) {
					classCount += count;
				} else if (name.includes("Teachers")) {
					teacherCount += count;
				} else {
					console.error("Unknown line item type:", name)
				}				
			}
		})

		deal.value = value;

		deal.custom_fields = deal.custom_fields || {};
		deal.custom_fields["Class Count"] = classCount;
		deal.custom_fields["Teacher Count"] = teacherCount;
		deal.custom_fields["Reading Level Diagnostics"] = hasRLDs;
		deal.custom_fields["Plan Type"] = plan;

		return { classCount, teacherCount, hasRLDs, value };


	}

	//////////////////////////////
	// Renders ///////////////////
	//////////////////////////////

	renderEstimateDetails() {
		var estimate = this.selectedEstimate();

		if (estimate) {
			return (
				<div className="row">
					<div className="col-sm-5">
						<strong>Selected Estimate</strong>: No. { estimate.doc_number }<br/>
						<strong>Amount</strong>: { $wr.centsToDollars(estimate.total * 100) }<br/>
						<strong>Plan</strong>: { estimate.plan } { estimate.has_rlds ? " + RLDs" : "" }
					</div>
					<div className="col-sm-7">
						<table className="table table-striped table-bordered">
							<tbody>
								<tr>
									<th>Product</th>
									<th>Amount</th>
								</tr>
								{ 
									estimate.line_items.map((line, index) => {
										var detail = line.sales_line_item_detail;
										if (detail) {
											return (
												<tr key={ index }>
													<td>{ detail.item_ref.name }</td>
													<td>{ parseInt(detail.quantity) }</td>
												</tr>
											)									
										}
									})
								}
							</tbody>
						</table>
					</div>
				</div>
			)
		}
	}

	renderEstimateSection() {
		var estimates = _.sortBy(this.props.estimates, "txn_date").reverse();
		var estimateOptions = estimates.map((estimate) => {
			if (estimate.has_rlds) {
				var rlds = " + RLDs"
			}
			return (
				<option key={ estimate.id } value={ estimate.id }>
					{ $wr.formatDate(estimate.txn_date, "YYYY-MM-DD") }:{" "}
					{ $wr.centsToDollars(estimate.total * 100) }{" "}
					{ estimate.plan }{ rlds }
				</option>
			)
		})

		return (
			<div className="estimateSection">
				<label className="estimateSelector">
					Estimate
					<select className="form-control"
						value={ this.state.selectedEstimateID }
						onChange={ (e) => this.setState({ selectedEstimateID: e.target.value }) }>

						<option value="">Select estimate</option>
						{ estimateOptions }
					</select>
				</label>

				{ this.renderEstimateDetails() }
			</div>
		);
	}

	renderInvoiceNumber() {
		return (
			<div className="estimateSection">
				<label className="estimateSelector">
					Invoice Number
					<input className="form-control"
						value={ this.props.deal.custom_fields["Invoice No."] }
						readOnly disabled />
				</label>
			</div>
		);
	}

	renderPaymentMethodSelector() { 
		return (
			<label>
				Payment Method
				<select className="form-control"
					value={ this.state.paymentMethod }
					disabled={ this.state.selectedChange == "PO Received" }
					onChange={ (e) => this.setState({ paymentMethod: e.target.value }) }>
					<option></option>
					<option value="PO">PO</option>
					<option value="Check">Check</option>
					<option value="CC from Invoice">CC from Invoice</option>
					<option value="Wire Transfer">Wire Transfer</option>
					<option value="Signed Estimate/Invoice">Signed Estimate/Invoice</option>
					<option value="Unknown">Unknown</option>

				</select>
				<span className="helperText">
					Pick "PO" if there was a PO; ignore final method (check, CC, etc.)
				</span>
			</label>
		);
	}

	renderQBPaymentMethodSelector() {
		var options = _.pairs(this.props.qbPaymentConfig).map((keyVal) => {
			return (
				<option key={ keyVal[1] } value={ keyVal[1] }>
					{ keyVal[0] }
				</option>
			);
		})

		return (
			<label>
				Payment Method
				<select className="form-control"
					value={ this.state.qbPaymentMethodID }
					onChange={ (e) => this.setState({ qbPaymentMethodID: e.target.value }) }>
					<option></option>
					{ options }

				</select>
				<span className="helperText">
					Payment method they used to actually give us money (probably "Check")
				</span>
			</label>
		);
	}


	renderFundingSourceSelector() {
		return (
			<label>
				Funding Source
				<select className="form-control"
					value={ this.state.fundingSource }
					onChange={ (e) => this.setState({ fundingSource: e.target.value }) }>
					<option></option>
					<option value="District">District</option>
					<option value="School">School</option>
					<option value="PTA">PTA</option>
					<option value="Personal">Personal</option>
					<option value="Donation">Donation</option>
					<option value="Unknown">Unknown</option>
				</select>
			</label>
		);
	}

	renderPaymentIDField() {
		return (
			<label>
				{ this.state.paymentMethod == "PO" ? "PO Number" : "Payment ID" }
				
				<input className="form-control"
					onChange={ (e) => this.setState({ paymentID: e.target.value }) }
					value={ this.state.paymentID } />
				<span className="helperText">
					PO number, check number, wire transfer number, etc.
				</span>

			</label>
		)
	}

	renderDateField(dateKey, label) {
		if (this.state[dateKey]) {
			var val = moment(this.state[dateKey])			
		} else {
			var val = undefined;
		}
		return (
			<label>
				{ label }
				<DatePicker className="form-control"
					selected={ val }
					onChange={ (m) => this.setState({ [dateKey]: m ? m.format("YYYY-MM-DD") : "" }) } />
			</label>

		)
	}

	renderHeaderSection() {
		if (this.props.deal) {
			var dealName = this.props.deal.name;
			var dealLinkBase = "https://app.futuresimple.com/sales/deals/";
			var dealLink = (
				<a href={ dealLinkBase + this.props.deal.id } target="_blank">
					<Glyphicon icon="link" />
				</a>
			);
		}

		return (
			<div className="headerSection">
				<header className="pageHeader">
					<h1>
						Quote/PO/Payment Accepted/Received
					</h1>
				</header>

				<p>
					<strong>Deal</strong>: { dealName } { dealLink }
				</p>
			</div>
		);
	}

	renderStageChangeSection() {
		var paymentRef = this.props.deal.custom_fields["Payment Ref."];
		if (paymentRef) {
			var paymentRefMessage = (
				<p>
					<em>
						A payment has already been received for this deal!
						Payment Ref: { paymentRef }.
					</em>
				</p>
			)
		}
		return (
			<div className="receivedToggle">
				<p>
					<strong>Current Stage</strong>: { this.props.stage }<br/>
				</p>
				{ paymentRefMessage }
				<strong>Select Change:</strong><br/>
				<label className="normal">
					<input type="radio"
						checked={ this.state.selectedChange === "Quote Accepted" }
						disabled={ ["PO Received", "Quote Accepted"].includes(this.props.stage) }
						onChange={ () => this.setState({ selectedChange: "Quote Accepted" }) } />

					Quote Accepted
				</label><br />
				<label className="normal">
					<input type="radio"
						checked={ this.state.selectedChange === "PO Received" }
						disabled={ ["PO Received"].includes(this.props.stage) }
						onChange={ () => this.setState({ selectedChange: "PO Received", paymentMethod: "PO" }) } />

					PO Received
				</label><br />
				<label className="normal">
					<input type="radio"
						checked={ this.state.selectedChange === "Payment Received" }
						disabled={ !!paymentRef }
						onChange={ () => this.setState({ selectedChange: "Payment Received" }) } />

					Payment Received
				</label>
			</div>
		);
	}

	renderTaskForm() {
		return (
			<AgentTaskForm task={ this.effectiveTask() } onChange={ this.updateTask } />
		);
	}

	renderQuoteAcceptedForm() {
		return (
			<div className="receivedSection">
				<div className="row">
					<div className="col-sm-4">
						{ this.renderDateField("meetingDate", "Meeting Date") }
						<span className="helperText">
							OPTIONAL. Will default to { this.defaultMeetingDate() }
						</span>
					</div>
					<div className="col-sm-4">
						{ this.renderDateField("decisionDate", "Decision Date") }
					</div>
				</div>
			</div>
		);
	}

	renderPOReceivedForm() {
		if (this.state.poFileSize) {
			var kB = Math.round(this.state.poFileSize / 1000);
			var maxRecommended = 700;

			if (kB > maxRecommended) {
				var poFileHelperText = (
					<span className="helperText">
						File Size: { kB } kB. <strong class="redBold">OVER</strong> the max recommended size of { maxRecommended } kB.
					</span>
				);
			} else {
				var poFileHelperText = (
					<span className="helperText">
						File Size: { kB } kB. Max recommended size is { maxRecommended } kB.
					</span>
				);
			}
		}
		return (
			<div className="receivedSection">
				<div className="row">
					<div className="col-sm-3">
						{ this.renderPaymentMethodSelector() }
					</div>
					<div className="col-sm-3">
						<label>
							PO File
							<input className="form-control" type="file"
								ref={ this.poUploadRef } onChange={ this.onFileInput } />
						</label>
						{ poFileHelperText }
					</div>
					<div className="col-sm-3">
						{ this.renderPaymentIDField() }
					</div>
					<div className="col-sm-3">
						{ this.renderFundingSourceSelector() }
					</div>
				</div>
				<div className="row">
					<div className="col-sm-4">
						{ this.renderDateField("meetingDate", "Meeting Date") }
						<span className="helperText">
							OPTIONAL. Will default to { this.defaultMeetingDate() }
						</span>
					</div>
					<div className="col-sm-4">
						{ this.renderDateField("decisionDate", "Decision Date") }
					</div>
				</div>
				<div className="row">
					<div className="col-sm-3">
						<label>
							Payable Title
							<CRMTitleSelector value={ this.state.payableTitle }
								onChange={ (e) => this.setState({ payableTitle: e.target.value }) } />
						</label>
					</div>
					<div className="col-sm-2">
						<label>
							Payable First
							<input className="form-control" value={ this.state.payableFirstName }
								onChange={ (e) => this.setState({ payableFirstName: e.target.value }) } />
						</label>
					</div>
					<div className="col-sm-3">
						<label>
							Payable Last (or only)
							<input className="form-control" value={ this.state.payableLastName }
								onChange={ (e) => this.setState({ payableLastName: e.target.value }) } />
						</label>
					</div>
					<div className="col-sm-4">
						<label>
							Payable Email
							<input className="form-control" type="email" value={ this.state.payableEmail }
								onChange={ (e) => this.setState({ payableEmail: e.target.value }) } />
						</label>
					</div>
				</div>
				<span className="helperText reverseRowShift">
					OPTIONAL. Payable will be added to the deal as a contact belonging to the same org.
				</span>
			</div>
		);
	}

	renderPaymentReceivedForm() {
		return (
			<div className="receivedSection">
				<div className="row">
					<div className="col-sm-4">
						{ this.renderPaymentMethodSelector() }
					</div>
					<div className="col-sm-4">
						{ this.renderPaymentIDField() }
					</div>
					<div className="col-sm-4">
						{ this.renderFundingSourceSelector() }
					</div>
				</div>
				<br />
				<div className="row">
					<div className="col-sm-4">
						{ this.renderDateField("meetingDate", "Meeting Date") }
						<span className="helperText">
							OPTIONAL. Will default to { this.defaultMeetingDate() }
						</span>
					</div>
					<div className="col-sm-4">
						{ this.renderDateField("decisionDate", "Decision Date") }
					</div>
					<div className="col-sm-4">
						{ this.renderDateField("paymentDate", "Payment Date") }
					</div>
				</div>
				<br />
				<div className="row">
					<div className="col-sm-4">
						<label>
							QuickBooks Payment Ref.
							<input className="form-control" value={ this.state.paymentRef }
								placeholder="SDUSD-1234567"
								onChange={ (e) => this.setState({ paymentRef: e.target.value }) } />
						</label>
						<span className="helperText">
							Helps match payments in QuickBooks. For checks: 
							district initials + check number.
						</span>
					</div>
					<div className="col-sm-4">
						{ this.renderQBPaymentMethodSelector() }
					</div>
				</div>
			</div>
		);
	}

	renderActions(actions) {
		var buttons = actions.map((action, index) => {
			return (
				<LoadingButton key={ index } loading={ this.props.loading }
					text={ action[0] }
					className={ "btn " + action[2] }
					onClick={ action[1] } />
			)
		})

		return (
			<div className="actions">
				{ buttons }
			</div>
		);
	}

	render() {

		if (this.state.done) {
			var receivedSection = (
				<div className="receivedSection">
					<em>Done! Applied: { this.state.selectedChange }</em>
				</div>
			);

		} else if (["Won", "Lost"].includes(this.props.stage)) {
			var receivedSection = (
				<div className="receivedSection">
					<em>{ this.props.stage } is not a valid stage for this page.</em>
				</div>
			);

		} else {

			var stageChangeSection = this.renderStageChangeSection();

			if (this.state.selectedChange) {
				if (this.state.selectedChange === "Payment Received") {

					if (this.props.stage === "PO Received") {
						var qbItemSection = this.renderInvoiceNumber();
					} else {
						var qbItemSection = this.renderEstimateSection();						
					}

					var receivedSection = this.renderPaymentReceivedForm();
					var actions = this.renderActions([
						["Payment Received", this.submitPaymentRecevied, "buttonPrimary"]
					]);
					var taskForm = this.renderTaskForm();

				} else {
					var qbItemSection = this.renderEstimateSection();

					if (this.state.selectedEstimateID) {
						if (this.state.selectedChange === "Quote Accepted") {
							var receivedSection = this.renderQuoteAcceptedForm();
							var actions = this.renderActions([
								["Accept Quote", this.submitQuoteAccepted, "buttonPrimary"]
							]);

						} else if (this.state.selectedChange === "PO Received") {
							var receivedSection = this.renderPOReceivedForm();
							var actions = this.renderActions([
								["Create Invoice", this.submitPORecevied, "buttonPrimary"]
							]);
						}
						var taskForm = this.renderTaskForm();
					}
				}

			}
		}

		return (
			<div className="dealReceivedPage container">
				{ this.renderHeaderSection() }
				{ stageChangeSection }

				{ qbItemSection }

				{ receivedSection }
				{ taskForm }
				{ actions }
			</div>
		);
	}

};

var DEAL_LINK_BASE = "https://app.futuresimple.com/sales/deals/";

DealReceivedPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	deal: PropTypes.object,
	stage: PropTypes.string,
	loading: PropTypes.bool,
	estimates: PropTypes.array,
	qbPaymentConfig: PropTypes.object,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	createInvoice: PropTypes.func.isRequired,
	registerPayment: PropTypes.func.isRequired,
	updateDeal: PropTypes.func.isRequired,
});

module.exports = DealReceivedPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/DealReceivedPage.js